export class Address{
    Name : string;
    Cel : string;
    PostalCode: string;
    Street : string;
    Number : number;
    Complement : string;
    PaymentType : number;
}